import List from "@/components/list";

const Table = args => {
  const RCSelectionChange = args.listeners["selection-change"] || function() {};

  const AccountTableConfig = [
    /* {
      type: "selection",
      label: "main"
    },*/
    {
      label: "短信内容",
      prop: "smsContent",
      minWidth: 160,
      showOverflowTooltip: true
    },
    {
      label: "业务类型",
      prop: "smsBizTypeName",
      minWidth: 120
    },
    {
      label: "手机号码",
      prop: "toMobile",
      minWidth: 130
    },
    {
      label: "接收人",
      prop: "toUserName",
      minWidth: 120
    },
    {
      label: "单位及职务",
      prop: "unitPosition",
      minWidth: 120
    },
    {
      label: "所属单位",
      prop: "deptName",
      minWidth: 120,
      showOverflowTooltip: true
    },
    {
      label: "最后发送时间",
      prop: "smsSendDate",
      minWidth: 140,
      showOverflowTooltip: true
    }
    /*{
      label: "操作",
      render: vo => <Deal vo={vo} />
    }*/
  ];
  return (
    <div>
      <List
        {...args}
        onSelectionChange={RCSelectionChange}
        talbeCols={AccountTableConfig}
      />
    </div>
  );
};

export default Table;
